export const MESSENGER_ACTION_DESIGN_RATED = 'messenger-design-rated';
export const MESSENGER_ACTION_IMAGE_SELECTED = 'messenger-image-selection-change';
export const MESSENGER_ACTION_IMAGE_TEXT_CARD_SELECTED = 'messenger-image-with-text-card-selected';
export const MESSENGER_ACTION_INITIAL_MESSAGES_LOADED = 'messenger-initial-messages-loaded';
export const MESSENGER_ACTION_NEXT_PAGE_LOADED = 'messenger-next-page-loaded';
export const MESSENGER_ACTION_SELECT_LAYOUT = 'messenger-layout-selected';
export const MESSENGER_ACTION_SEND_COMPLETE = 'messenger-message-send-complete';
export const MESSENGER_ACTION_UPDATE_MESSAGE = 'messenger-update-message';
export const MESSENGER_ACTION_UPDATE_COMPLETE = 'messenger-message-update-complete';
export const MESSENGER_ACTION_CANCEL_CLICKED = 'messenger-cancel-clicked';
export const MESSENGER_APPEND_CS_TICKET_MESSAGE = 'messenger-append-cs-ticket-message';
export const MESSENGER_ACTION_SAVE_DRAFT_STATE = 'save-draft-js-state';
export const MESSENGER_BACK_CLICKED = 'messenger-back-clicked';
export const MESSENGER_BAD_FILE_TYPE_MODAL_CLOSE = 'bad-file-type-modal-close-request';
export const MESSENGER_BAD_FILE_TYPE_MODAL_CONFIRM = 'bad-file-type-modal-confirm-button-clicked';
export const MESSENGER_CLEAR_TEXT_FIELD = 'messenger-clear-text-field';
export const MESSENGER_EXIT_FULL_SCREEN_FILES = 'messenger-exit-full-screen-files';
export const MESSENGER_LOAD_ADDITIONAL_MESSAGES = 'messenger-load-more-messages';
export const MESSENGER_LOADING_STATE_CHANGE = 'messenger-loading-state-changed';
export const MESSENGER_MULTI_SELECT_CHANGED = 'messenger-selections-change';
export const MESSENGER_REVISION_CLICKED = 'request-revision-button-clicked';
export const MESSENGER_SELECTED_SPACE_CHANGE = 'messenger-selected-space-changed';
export const MESSENGER_SELECT_FULL_SCREEN_FILE = 'messenger-select-full-screen-file';
export const MESSENGER_SELECT_LAST_FULL_SCREEN_FILE = 'messenger-select-last-full-screen-file';
export const MESSENGER_SELECT_NEXT_FULL_SCREEN_FILE = 'messenger-select-next-full-screen-file';
export const MESSENGER_RESEND_MESSAGE = 'messenger-resend-message';
export const MESSENGER_SEND_MESSAGE = 'messenger-send-message';
export const MESSENGER_SENDING_STATE_CHANGED = 'messenger-sending-state-changed';
export const MESSENGER_SET_ACTIVE_TEXT_FIELD = 'messenger-set-active-text-field';
export const MESSENGER_SET_BAD_FILE_UPLOAD = 'messenger-set-unaccepted-file-error';
export const MESSENGER_SET_DRAG_IMAGE = 'messenger-set-drag-image';
export const MESSENGER_SET_FULL_SCREEN_FILES = 'messenger-set-full-screen-files';
export const MESSENGER_SET_INPUT_DISABLED = 'messenger-set-input-disabled';
export const MESSENGER_SET_INPUT_FILES = 'messenger-set-message-files';
export const MESSENGER_SET_OWNER_ID = 'messenger-set-owner-id';
export const MESSENGER_SET_MESSAGES = 'messenger-set-messages';
export const MESSENGER_SET_SHOW_FOOTER = 'messenger-set-show-footer';
export const MESSENGER_SET_SHOW_TYPING_INDICATOR = 'messenger-set-show-typing-indicator';
export const MESSENGER_SET_REDESIGN_IN_PROGRESS = 'messenger-redesign-in-progress';
export const MESSENGER_START_REDESIGN = 'messenger-start-redesign';
export const MESSENGER_SUBMITTED_MULTI_SELECT = 'messenger-multi-select-submission';
export const MESSENGER_TEXT_CHANGED = 'messenger-message-text-changed';
export const MESSENGER_LOCAL_TEXT_CHANGED = 'messenger-message-local-text-changed';
export const MESSENGER_UPDATE_CONVERSATION = 'messenger-update-conversation';
export const MESSENGER_UPDATE_DRAFT_STATE = 'set-saved-draft-js-state';
export const MESSENGER_UPDATE_LAST_SINCE_DATE = 'messenger-update-last-since-date';
export const MESSENGER_UPDATE_TARGET_DESIGN = 'messenger-update-target-design';
export const MESSENGER_X_OUT_CLICKED = 'messenger-xout-clicked';
export const OPEN_MESSENGER = 'messenger-open';

export const DEFAULT_REDESIGN_REQUEST_MESSAGE = `I'd like to start a redesign`;
export const MESSAGE_SEND_FAILED_COPY = 'Message not sent. Tap to retry.';
export const REDESIGN_REQUEST_FLOW_NAME = 'redesign_request';

export const BAD_FILE_TYPES_MESSAGE = (fileTypesString, supportedTypesString) =>
  `Sorry, ${fileTypesString} files are currently not supported\n\nWe currently support ${supportedTypesString}`;
export const ALSO_HAS_ACCEPTED_MESSAGE = '\n\n(Don’t worry your other files will upload.)';
